
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hang-over",
      function () {
        return require("private-next-pages/hang-over/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hang-over"])
      });
    }
  